import type { Logger } from '@wix/fe-essentials/bi';
import { createContext, useContext } from 'react';

export const BiContext = createContext<Logger | undefined>(undefined);

export type { Logger };

export function useBi() {
  const context = useContext(BiContext);
  if (context === undefined) {
    throw new Error('useBi must be used within a BiProvider');
  }
  return context;
}
